import { AppConfig } from '@app/config/app.config';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from '@app/base/service/modal.service';

declare var $: any;

@Component({
    selector: 'sa-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
    public AppConfig;
    public UrlBase;
    public urlPastoral;

	canShowNewExperience: boolean;
    redirPath: string = '#/dashboard';

    constructor(
        private router: Router,
        private modalService: ModalService,
    ) {

        this.AppConfig = AppConfig;
        this.UrlBase = AppConfig.settings.env.urlBase;
        this.urlPastoral = AppConfig.settings.env.urlPastoral;
        const diocesesDbCentraCanShow = JSON.parse(AppConfig.settings.env.configurations.diocesesDbCentraCanShowNewExperience) as number[];
		this.canShowNewExperience = !diocesesDbCentraCanShow.length || diocesesDbCentraCanShow.includes(Number(JSON.parse(window.localStorage.getItem('loginToken')).dioceseIdDbCentral));
    }

    ngOnInit() {
    }

    searchMobileActive = false;

    inicio() {
        window.location.href = `${AppConfig.settings.env.urlBase + this.redirPath}`;
    }

    toggleSearchMobile() {
        this.searchMobileActive = !this.searchMobileActive;

        $('body').toggleClass('search-mobile', this.searchMobileActive);
    }

    onSubmit() {
        this.router.navigate(['/miscellaneous/search']);
    }

    trocarOrganismo() {
        this.modalService.open('changeorganismo');
    }

    logout() {
        localStorage.removeItem('loginToken');
        localStorage.removeItem('permissions');
        localStorage.removeItem('permissionsAccounting');
        location.href = AppConfig.settings.env.urlLogin;
    }

  handleNewExperience() {
    localStorage.removeItem('isNewExperience');
    localStorage.setItem('isNewExperience','true');
    window.location.href = `${this.UrlBase}/mod-tribunal/#/tribunal`;
  }
}